import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./pages/App/App";
import reportWebVitals from "./utils/reportWebVitals";
import { HomePage } from "./components/Titles/Home";
/* import { PrimeReactProvider } from "primereact/api"; */
/* import "primeicons/primeicons.css";
import "primereact/resources/themes/lara-light-indigo/theme.css"; */

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);

if (window.location.pathname === "/remedy") {
    root.render(<App />);
} else {
    root.render(<HomePage />);
}

/* root.render(
    // TODO: Return it back, but only in dev mode
    // <React.StrictMode>

    /*<PrimeReactProvider>
        <App />
    </PrimeReactProvider>,
    <App />,
    // </React.StrictMode>,
); */

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
